import { render } from "./SearchProductsFilter.vue?vue&type=template&id=21c74129"
import script from "./SearchProductsFilter.vue?vue&type=script&lang=js"
export * from "./SearchProductsFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__